import * as React from "react";
const SvgHeartFill = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} fill="none" {...props}>
    <g fillRule="evenodd" clipRule="evenodd">
      <path
        fill="#F53F29"
        d="M20.421 14.995c-.42-2.339-2.462-4.095-4.883-3.99-2.96.126-4.988 3.062-4.452 6.054.829 4.633 6.435 7.573 9.414 12.398 2.98-4.825 8.585-7.765 9.414-12.398.536-2.992-1.492-5.928-4.452-6.055-2.42-.104-4.462 1.652-4.884 3.991z"
      />
      <path
        fill="#fff"
        d="M19.514 28.036c-1.062-1.384-2.302-2.622-3.503-3.82-2.29-2.286-4.437-4.428-4.925-7.157-.536-2.992 1.493-5.928 4.451-6.055 1.653-.07 3.13.725 4.034 1.982a4.9 4.9 0 0 1 .85 2.01h.157l.006-.03c.136-.731.43-1.404.845-1.98.904-1.257 2.38-2.053 4.033-1.982 2.96.127 4.988 3.063 4.452 6.055-.488 2.73-2.634 4.871-4.924 7.157-1.201 1.198-2.442 2.436-3.504 3.82-.35.456-.682.929-.986 1.421a17 17 0 0 0-.986-1.421m.986-16.45c-1.214-1.4-3.015-2.267-5.031-2.18-4.087.175-6.635 4.155-5.958 7.935M20.5 11.585c1.214-1.398 3.015-2.266 5.031-2.18 4.088.176 6.635 4.156 5.958 7.936-.51 2.852-2.466 5.06-4.332 6.965q-.546.554-1.084 1.09c-1.59 1.589-3.095 3.094-4.211 4.902a1.6 1.6 0 0 1-2.723 0c-1.117-1.808-2.622-3.313-4.212-4.902q-.538-.536-1.083-1.09C11.977 22.4 10.02 20.193 9.51 17.34"
      />
    </g>
  </svg>
);
export default SvgHeartFill;
